import { SHOWROOMS, CONTACTS, INSTAGRAM, WHATSAPP_MAIN } from "../../data/site";
import { Reveal, Label } from "./Reveal";
import { Phone, MessageCircle, MapPin, Navigation, Instagram } from "lucide-react";

export const Locations = () => (
  <section id="locations" className="relative py-24 md:py-32 bg-[#0d0d0d] border-t border-white/10">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <Reveal>
        <Label>Visit us</Label>
        <h2 className="mt-4 font-heading text-4xl sm:text-6xl font-bold uppercase tracking-tighter text-white">
          Our <span className="text-red-600">showrooms</span>
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {SHOWROOMS.map((s, i) => (
          <Reveal key={s.name} delay={i * 0.1}>
            <div className="border border-white/10 bg-[#111] overflow-hidden group">
              <div className="relative h-56 md:h-64 overflow-hidden">
                <iframe
                  title={s.name}
                  src={s.embed}
                  className="w-full h-full grayscale contrast-125 opacity-80 group-hover:opacity-100 group-hover:grayscale-0 transition-all duration-500"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div className="p-6">
                <div className="flex items-start gap-3">
                  <MapPin className="text-red-600 mt-1 shrink-0" size={20} />
                  <div>
                    <h3 className="font-heading text-xl font-semibold uppercase text-white">{s.name}</h3>
                    <p className="text-zinc-400 text-sm mt-1">{s.blurb}</p>
                  </div>
                </div>
                <div className="mt-5 flex flex-wrap gap-3">
                  <a href={`tel:${s.phone}`} data-testid={`show-call-${i}`} className="flex items-center gap-2 border border-white/15 hover:border-white text-white text-sm font-semibold px-4 py-2.5 transition-colors">
                    <Phone size={15} /> {s.phone}
                  </a>
                  <a href={`https://wa.me/91${s.phone}`} target="_blank" rel="noreferrer" data-testid={`show-wa-${i}`} className="flex items-center gap-2 bg-[#25D366]/90 hover:bg-[#25D366] text-black text-sm font-bold px-4 py-2.5 transition-colors">
                    <MessageCircle size={15} /> WhatsApp
                  </a>
                  <a href={s.map} target="_blank" rel="noreferrer" data-testid={`show-map-${i}`} className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white text-sm font-bold px-4 py-2.5 transition-colors">
                    <Navigation size={15} /> Directions
                  </a>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      {/* contact strip */}
      <Reveal>
        <div className="mt-6 border border-white/10 bg-[#111] p-6 md:p-9">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div>
              <h3 className="font-heading text-2xl font-semibold uppercase text-white">Call our team</h3>
              <p className="text-zinc-400 text-sm mt-1">One quick call — sales, service or general help.</p>
            </div>
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="instagram-link" className="inline-flex items-center gap-2 text-white font-semibold hover:text-red-500 transition-colors">
              <Instagram size={18} /> @sasyahero
            </a>
          </div>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {CONTACTS.map((c) => (
              <div key={c.phone} className="border border-white/10 p-4 hover:border-red-600/50 transition-colors">
                <div className="text-xs uppercase tracking-widest text-zinc-500">{c.label}</div>
                <div className="mt-2 font-heading text-xl text-white">{c.phone}</div>
                <div className="mt-3 flex gap-2">
                  <a href={`tel:${c.phone}`} data-testid={`contact-call-${c.phone}`} className="flex-1 flex items-center justify-center gap-1.5 bg-red-600 hover:bg-red-700 text-white text-xs font-bold uppercase py-2 transition-colors">
                    <Phone size={13} /> Call
                  </a>
                  <a href={`https://wa.me/91${c.phone}`} target="_blank" rel="noreferrer" data-testid={`contact-wa-${c.phone}`} className="flex-1 flex items-center justify-center gap-1.5 border border-white/15 hover:border-[#25D366] text-white text-xs font-bold uppercase py-2 transition-colors">
                    <MessageCircle size={13} /> Chat
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>

    {/* floating WhatsApp */}
    <a
      href={`https://wa.me/${WHATSAPP_MAIN}`}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-black/40 hover:scale-110 transition-transform"
      aria-label="WhatsApp us"
    >
      <MessageCircle className="text-black" size={26} />
    </a>
  </section>
);
